// Module
var code = " <div layout=\"column\" layout-align=\"start end\"> <p ng-style=\"$ctrl.getCounterStyles()\"> <span ng-bind-html=\"$ctrl.getTotalRaised()\"></span> </p> </div> ";
// Exports
export default code;